import { Bar } from "react-chartjs-2";

export function BarChartComponent({
  dataStats,
  timeFilterSuffix,
  selectedDateFilter,
  isMobile,
}) {
  const dataBar = {
    labels: ["Sent", "Delivered", "Read", "Sales"],
    datasets: [
      {
        data: [
          dataStats?.[`sent${timeFilterSuffix}`],
          dataStats?.[`delivered${timeFilterSuffix}`],
          dataStats?.[`read${timeFilterSuffix}`],
          selectedDateFilter === "allData"
            ? dataStats?.attributedOrdersShopify
            : dataStats?.[`sales${timeFilterSuffix}`],
        ],
        absoluteValues: [
          dataStats?.[`sent${timeFilterSuffix}`],
          dataStats?.[`delivered${timeFilterSuffix}`],
          dataStats?.[`read${timeFilterSuffix}`],
          selectedDateFilter === "allData"
            ? dataStats?.attributedOrdersShopify
            : dataStats?.[`sales${timeFilterSuffix}`],
        ],
        totalValue: dataStats?.[`messagesCount${timeFilterSuffix}`],
        backgroundColor: [
          "rgba(161, 161, 170, 0.4)",
          "rgba(34, 24, 75, 0.4)",
          "rgba(250, 199, 12, 0.4)",
          "rgba(5, 122, 85, 0.4)",
        ],
        borderColor: ["#A1A1AA", "#22184B", "#FAC70C", "#16A34A"],
        borderWidth: 1,
      },
      {
        type: "line",
        label: `Total targeted recipients : ${
          dataStats?.[`messagesCount${timeFilterSuffix}`]
        }`,
        data: [
          dataStats?.[`messagesCount${timeFilterSuffix}`],
          dataStats?.[`messagesCount${timeFilterSuffix}`],
          dataStats?.[`messagesCount${timeFilterSuffix}`],
          dataStats?.[`messagesCount${timeFilterSuffix}`],
        ],
        borderColor: "#DF0F63",
        borderWidth: 2,
        fill: false,
        pointRadius: 0,
        pointHitRadius: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        labels: {
          generateLabels: function (chart) {
            const data = chart.data;
            if (data.datasets.length) {
              return [
                {
                  text: data.datasets[1].label,
                  fillStyle: "transparent",
                  fontColor: data.datasets[1].borderColor,
                  hidden: false,
                  lineWidth: 0,
                },
              ];
            }
            return [];
          },
        },
      },
      tooltip: {
        backgroundColor: "#FAFAFA",
        borderColor: "#52525b",
        borderWidth: 0.9,
        titleColor: "#000000",
        bodyColor: "#000000",
        cornerRadius: 10,
        xAlign: "center",
        callbacks: {
          label: function (tooltipItem) {
            const dataset = tooltipItem.dataset;
            const index = tooltipItem.dataIndex;
            const absolute = dataset.absoluteValues[index];
            return `${absolute}/${dataset.totalValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          display: false,
        },
        offset: true,
      },
      y: {
        beginAtZero: true,
      },
    },
    ...(isMobile ? {} : { aspectRatio: 2.2 }),
    maintainAspectRatio: true,
  };

  return (
    <div className="mx-auto h-full flex flex-col justify-between">
      <div className="text-lg font-bold">Sending rates</div>
      <div className="mx-auto w-full mt-3">
        <Bar data={dataBar} options={options} />
      </div>
    </div>
  );
}
